/* ============================================================
   Latest Reels — section script
   - Works for multiple instances of the section on one page.
   - Arrow buttons scroll by one viewport "page".
   - Dots are generated dynamically based on however many reel
     blocks the merchant has added, so adding/removing reels in
     the theme editor just works — no code changes needed.
   ============================================================ */
(function () {
  'use strict';

  function initReelsSection(root) {
    var track = root.querySelector('[data-reels-track]');
    if (!track) return;

    var prevBtn = root.querySelector('[data-reels-prev]');
    var nextBtn = root.querySelector('[data-reels-next]');
    var dotsWrap = root.querySelector('[data-reels-dots]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-reels-card]'));

    var autoplay = root.getAttribute('data-autoscroll') === 'true';
    var autoplaySpeed = parseInt(root.getAttribute('data-autoscroll-speed'), 10) || 4000;
    var autoplayTimer = null;

    function maxScrollLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function pageCount() {
      if (track.clientWidth === 0) return 1;
      // Math.ceil (not round) so any remaining overflow still counts as
      // a reachable page — rounding down here was why Prev/Next could
      // appear to have "nothing left" even when more content existed.
      return Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
    }

    function currentPage() {
      var max = maxScrollLeft();
      if (max <= 0) return 0;
      var pages = pageCount();
      if (pages <= 1) return 0;
      // Map real scroll progress (0 → 1) onto the dot index, so the
      // active dot is driven by how far the track has actually scrolled
      // rather than a clientWidth-rounded guess. This guarantees the
      // last dot is only active exactly when scrolled all the way,
      // matching the true last visible card on any device.
      var progress = track.scrollLeft / max;
      return Math.round(progress * (pages - 1));
    }

    function scrollToPage(index) {
      var pages = pageCount();
      var clamped = Math.max(0, Math.min(index, pages - 1));
      var left = Math.min(clamped * track.clientWidth, maxScrollLeft());
      track.scrollTo({ left: left, behavior: 'smooth' });
    }

    // Arrow clicks move by a fixed distance based on current scroll
    // position and the hard scrollWidth/clientWidth limits, instead of
    // snapping to a computed "page" — this guarantees the button always
    // moves the track as long as there is scroll room left, regardless
    // of how many reels are visible per breakpoint.
    function scrollByAmount(amount) {
      var max = maxScrollLeft();
      var target = Math.max(0, Math.min(track.scrollLeft + amount, max));
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function updateArrowState() {
      if (!prevBtn || !nextBtn) return;
      var max = maxScrollLeft();
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= max - 1;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pages = pageCount();
      if (pages <= 1) return;

      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'reels-dots__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to reels page ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () {
            stopAutoplay();
            scrollToPage(idx);
          });
        })(i);
        dotsWrap.appendChild(dot);
      }
      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.reels-dots__dot');
      var active = currentPage();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
      });
    }

    function startAutoplay() {
      if (!autoplay || cards.length <= 1) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        var pages = pageCount();
        var next = currentPage() + 1;
        if (next >= pages) next = 0;
        scrollToPage(next);
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    var scrollRaf = null;
    track.addEventListener('scroll', function () {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(function () {
        updateArrowState();
        updateDots();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplay();
        scrollByAmount(-track.clientWidth * 0.9);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplay();
        scrollByAmount(track.clientWidth * 0.9);
      });
    }

    // Click-and-drag scrolling for desktop mouse users is the only
    // mouse-driven scroll method (press, hold, and drag left/right).
    // Native touch swipe and trackpad two-finger swipe still work as
    // the browser's own default behaviour; plain mouse-wheel scrolling
    // is intentionally not supported.
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragMoved = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // native touch scrolling handles this already
      isDragging = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragStartScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      stopAutoplay();
    });

    window.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      var delta = e.clientX - dragStartX;
      if (Math.abs(delta) > 3) dragMoved = true;
      track.scrollLeft = dragStartScroll - delta;
    });

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    // Prevent a drag-release from also triggering a click on links/buttons
    // (play button, caption link, etc.) underneath the pointer.
    track.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);

    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('touchstart', stopAutoplay, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buildDots();
        updateArrowState();
      }, 150);
    });

    buildDots();
    updateArrowState();
    startAutoplay();
    initVideos(root);
  }

  // Pause every other reel video on the page when one starts playing,
  // so multiple reels never play (and compete for sound) at once.
  function pauseOtherVideos(current) {
    document.querySelectorAll('.reels-card__video').forEach(function (v) {
      if (v !== current && !v.paused) v.pause();
    });
  }

  function initVideos(root) {
    // Click-to-play reels
    root.querySelectorAll('[data-reels-play]').forEach(function (btn) {
      var media = btn.closest('[data-reels-media]');
      var video = media ? media.querySelector('.reels-card__video') : null;
      if (!video) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        pauseOtherVideos(video);
        video.controls = true;
        video.muted = false;
        media.classList.add('is-playing');
        // Once native controls take over, this custom overlay button is
        // retired for good — it must not reappear on pause, since the
        // native controls already show their own play/pause icon and
        // showing both at once was the "two pause buttons" bug.
        btn.style.display = 'none';
        video.play();
      });
    });

    // Autoplay-muted reels: play when scrolled into view, pause when not,
    // plus a manual mute/unmute toggle.
    root.querySelectorAll('[data-reels-media][data-playback="autoplay_muted"]').forEach(function (media) {
      var video = media.querySelector('.reels-card__video');
      var muteBtn = media.querySelector('[data-reels-mute]');
      if (!video) return;

      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.muted = !video.muted;
          muteBtn.classList.toggle('is-muted', video.muted);
          var mutedIcon = muteBtn.querySelector('.icon-muted');
          var unmutedIcon = muteBtn.querySelector('.icon-unmuted');
          if (mutedIcon && unmutedIcon) {
            mutedIcon.style.display = video.muted ? '' : 'none';
            unmutedIcon.style.display = video.muted ? 'none' : '';
          }
          if (!video.muted) pauseOtherVideos(video);
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.6 });
        observer.observe(video);
      }
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.reels-section');
    sections.forEach(initReelsSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a section is added/re-rendered inside the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.reels-section');
    if (el) initReelsSection(el);
  });
})();